import { FC } from "react";

import { Accordion } from "components/organisms/Accordion/Accordion";
import { Container } from "components/organisms/Container/Container";
import { AccordionRecord } from "@graphql/types/graphql";

export const CBAccordion: FC<AccordionRecord> = ({ items, timeline }) => (
    <Accordion items={items} timeline={timeline ?? false} />
);
